import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Collapse,
  Avatar,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Select,
  MenuItem,
  Tab,
  Tabs,
  Button,
  Modal,
  Checkbox,
  FormControlLabel,
  Snackbar,
  Alert,
  TablePagination,
} from "@mui/material";
import { jsPDF } from 'jspdf';
import {
  ExpandMore,
  ExpandLess,
  Notifications,
  CalendarToday,
  Print,
} from "@mui/icons-material";
import {  VendorappBar } from "../../../components";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch } from "../../../hooks";
import { useSelector } from "react-redux";

export default function PaymentManagement({onBackScreenName}) {
  const [openRowId, setOpenRowId] = useState(null); // Tracks expanded row
  const [searchText, setSearchText] = useState("");
  const [sortOrder, setSortOrder] = useState("recent");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [transPage, setTransPage] = useState(0);
  const [transRowsPerPage, setTransRowsPerPage] = useState(10);
  const [transSortOrder, setTransSortOrder] = useState("recent");
    const [selectedTab, setSelectedTab] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("This Month");
    const [requestDate, setRequestDate] = useState(new Date().toISOString().split("T")[0]); // Default to current date
    const handleModalOpen = () => setOpenModal(true);
    const handleModalClose = () => setOpenModal(false);
    const [amount, setAmount] = useState("");
    const [isTotalAmount, setIsTotalAmount] = useState(false);
    const [isSubmittingWithdraw, setIsSubmittingWithdraw] = useState(false);

    // Snackbar state
    const [snackbarState, setSnackbarState] = useState({
      open: false,
      message: "",
      status: false,
    });

    // Get vendor details from Redux store
    const userDetails = useSelector((state) => state.user.userdetails);
  const loginToken = useSelector((state) => state.user.logintoken);
  const { id } = useSelector((state) => state.user.userdetails);


    // API call to fetch delivered orders
    const {
      data: deliveredOrdersData,
      isLoading: deliveredOrdersLoading,
      error: deliveredOrdersError,
      fetchData: fetchDeliveredOrders,
    } = useFetch(BASE_URL_TEST + urls("getMyOrders"), {
      method: "POST",
       headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call to fetch vendor products
    const {
      data: vendorProductsData,
      isLoading: vendorProductsLoading,
      error: vendorProductsError,
      fetchData: fetchVendorProducts,
    } = useFetch(BASE_URL_TEST + urls("getAllVProducts", id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call to fetch payment requests
    const {
      data: paymentRequestsData,
      isLoading: paymentRequestsLoading,
      error: paymentRequestsError,
      fetchData: fetchPaymentRequests,
    } = useFetch(BASE_URL_TEST + urls("getVendorPaymentRequests"), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call for withdraw request
    const {
      data: withdrawRequestData,
      isLoading: withdrawRequestLoading,
      error: withdrawRequestError,
      fetchData: fetchWithdrawRequest,
    } = useFetch(BASE_URL_TEST + urls("withDrawRequest"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call to fetch listing orders (Agent Orders)
    const {
      data: listingOrdersResponse,
      isLoading: isListingOrdersLoading,
      fetchData: fetchListingOrders,
    } = useFetch(BASE_URL_TEST + urls("getListingOrders"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // API call to fetch vendor listings (for Agent Total Order count)
    const {
      data: vendorListingsResponse,
      isLoading: isVendorListingsLoading,
      fetchData: fetchVendorListings,
    } = useFetch(BASE_URL_TEST + urls("getVendorListings"), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

     const {
      data: agentMetricsData,
      isLoading: isAGentMetricsLoading,
      fetchData: fetchAgentMetrics,
    } = useFetch(BASE_URL_TEST + urls("getAgentMetrics",userDetails.vendor_id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

    // Invoice Download Modal States
    const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
    const [selectedInvoiceData, setSelectedInvoiceData] = useState(null);

  const handleInvoiceModalOpen = (
  orderId,
  orderItem,
  orderDetails,
  customerDetails,
  vendorDetails,
  orderSummary
) => {
  setSelectedInvoiceData({
    orderId,
    orderItem,
    orderDetails,
    customerDetails,
    vendorDetails,
    orderSummary,
  });
  setOpenInvoiceModal(true);
};
    const handleInvoiceModalClose = () => {
      setOpenInvoiceModal(false);
      setSelectedInvoiceData(null);
    };

    // Fetch delivered orders and vendor products on component mount
    useEffect(() => {
      if (userDetails && userDetails.vendor_id && loginToken) {
        fetchDeliveredOrders({
          vendor_id: userDetails.vendor_id,
          order_status: "DELIVERED"
        });
        fetchVendorProducts();
        // Fetch payment requests with status filter
        fetchPaymentRequests(null, `?vendor_id=${userDetails.vendor_id}&status=pending`);
        // Fetch listing orders (Agent Orders)
        fetchListingOrders({
          vendor_id: userDetails.vendor_id,
           order_status: "DELIVERED"
        });
        // Fetch vendor listings for agent count
        fetchVendorListings();
        fetchAgentMetrics({
          vendor_id: userDetails.vendor_id
        });
      }
    }, [userDetails, loginToken]);

    // Derive stats directly from API responses to avoid stale state issues
    const totalSold = deliveredOrdersData?.data?.total_orders ?? 0;
    const totalValue = deliveredOrdersData?.data?.total_amount ?? 0;
    const totalProducts = vendorProductsData?.data?.length ?? 0;
    const unitsSold = agentMetricsData?.data?.total_sold_units ?? 0;
    const totalRevenue = agentMetricsData?.data?.total_revenue ?? 0;
 const agentCount = agentMetricsData?.data?.agent_total_orders ?? 0;
const pendingBalance = agentMetricsData?.data?.pending_balance ?? 0;
    // Handle withdraw request response
    useEffect(() => {
      if (withdrawRequestError) {
        setSnackbarState({
          open: true,
          message: "An error occurred while submitting your request. Please try again.",
          status: false,
        });
        setIsSubmittingWithdraw(false);
      } else if (withdrawRequestData && withdrawRequestData["status"] === true) {
        setSnackbarState({
          open: true,
          message: withdrawRequestData["message"],
          status: withdrawRequestData["status"],
        });
        // Refresh payment requests to show the new request
        fetchPaymentRequests(null, `?vendor_id=${userDetails.vendor_id}&status=pending`);
        // Reset form and close modal
        setAmount("");
        setIsTotalAmount(false);
        handleModalClose();
        setIsSubmittingWithdraw(false);
      } else if (withdrawRequestData && withdrawRequestData["status"] === false) {
        setSnackbarState({
          open: true,
          message: withdrawRequestData["message"],
          status: withdrawRequestData["status"],
        });
        setIsSubmittingWithdraw(false);
      }
    }, [withdrawRequestData, withdrawRequestError]);

  useEffect(() => { setPage(0); }, [searchText, sortOrder]);
  useEffect(() => { setTransPage(0); }, [transSortOrder]);

  // Transform API data into rows format
  const rows = React.useMemo(() => {
    if (!deliveredOrdersData || !deliveredOrdersData.data || !deliveredOrdersData.data.ordersData) {
      return [];
    }

    return deliveredOrdersData.data.ordersData.map((order) => {
      // Format date
      const orderDate = new Date(order.created_at);
      const formattedDate = orderDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');

      // Determine status display
      const status = order.order_status || "Pending";

      // Calculate discount amount
      const couponDiscount = parseFloat(order.cartDetails?.coupon_discount || 0);
      const totalAmount = parseFloat(order.total_amount);
      const subtotalBeforeDiscount = totalAmount + couponDiscount;

      // Create order details array
      const orderDetails = [{
        sku: order.cart_vendor_id,
        name: order.vendorDetails?.shop_name || "Order",
        price: `₹${subtotalBeforeDiscount.toFixed(2)}`,
        qty: "x1",
        discount: couponDiscount > 0 ? `₹${couponDiscount.toFixed(2)}` : "₹0.00",
        total: `₹${totalAmount.toFixed(2)}`,
      }];

     const customerDetails = {
  name: `${order.cartDetails?.customerDetails?.first_name || ""} ${order.cartDetails?.customerDetails?.last_name || ""}`.trim(),
  phone: order.cartDetails?.customerDetails?.phone_number || "",
  email: order.cartDetails?.customerDetails?.email || "",
};

const vendorDetails = {
  shopName: order.vendorDetails?.shop_name || "N/A",
  vendorName: order.vendorDetails?.owner_name || "N/A",
  phone: order.vendorDetails?.phone_number || "N/A",
  email: order.vendorDetails?.email || "N/A",
  address: order.vendorDetails?.address || "N/A"
};

      return {
        id: order.cart_vendor_id,
        orderNumber: order.cart_number,
        rawDate: order.created_at,
        item: `Order #${order.cart_id}`,
        category: order.vendorDetails?.shop_name || 'N/A',
        date: formattedDate,
        price: `₹${totalAmount.toFixed(2)}`,
        paymentType: order.cartDetails?.payment_method || "N/A",
        status: status,
        customerName: `${order.cartDetails?.customerDetails?.first_name || ""} ${order.cartDetails?.customerDetails?.last_name || ""}`.trim() || order.cartDetails?.customerDetails?.phone_number || "N/A",
        customerPhone: order.cartDetails?.customerDetails?.phone_number || "N/A",
        customerEmail: order.cartDetails?.customerDetails?.email || "N/A",
        transactionId: order.cartDetails?.transaction_id || "N/A",
        distance: order.distance ? `${order.distance} km` : "N/A",
        details: orderDetails,
        summary: {
          subtotal: `₹${subtotalBeforeDiscount.toFixed(2)}`,
          shipping: "₹0.00",
          discount: couponDiscount > 0 ? `-₹${couponDiscount.toFixed(2)}` : "-₹0.00",
          total: `₹${totalAmount.toFixed(2)}`,
          coupon: order.cartDetails?.coupon || "N/A",
        },
        customerDetails,
        vendorDetails
      };
    });
  }, [deliveredOrdersData]);

  // // Calculate agent count from vendor listings
  // const agentCount = React.useMemo(() => {
  //   const listingsData = Array.isArray(vendorListingsResponse?.data)
  //     ? vendorListingsResponse.data
  //     : Array.isArray(vendorListingsResponse)
  //     ? vendorListingsResponse
  //     : [];

  //   return listingsData.length;
  // }, [vendorListingsResponse]);

  // Transform API data into transactions format
  const transactions = React.useMemo(() => {
    if (!paymentRequestsData || !paymentRequestsData.data) {
      return [];
    }

    return paymentRequestsData.data.map((request) => {
      // Format request date
      const requestedAt = new Date(request.requested_at);
      const formattedDate = requestedAt.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');

      // Format time
      const formattedTime = requestedAt.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

      // Get primary bank details
      const primaryBank = request.vendorDetails?.bankDetails?.find(bank => bank.is_primary === 1);
      const bankName = primaryBank?.bank_name || "N/A";
      const bankAccount = primaryBank?.account_number || "N/A";

      // Format payment date and time if available
      let paymentDateTime = "N/A";
      if (request.payment_date) {
        const paymentDate = new Date(request.payment_date);
        paymentDateTime = `${paymentDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).replace(/\//g, '-')} / ${paymentDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        })}`;
      }

      return {
        id: request.vpayment_id,
        rawDate: request.requested_at,
        requestDate: formattedDate,
        time: formattedTime,
        amount: parseFloat(request.amount).toLocaleString('en-IN'),
        bank: bankName,
        status: request.status.charAt(0).toUpperCase() + request.status.slice(1),
        details: {
          transactionId: request.transaction_id || "N/A",
          dateTime: paymentDateTime,
          bankAccount: bankAccount,
          receiptImage: request.payment_receipt || "/placeholder-receipt.png",
        },
      };
    });
  }, [paymentRequestsData]);

  const filteredSortedRows = React.useMemo(() => {
    return rows
      .filter((row) => {
        const q = searchText.toLowerCase();
        return (
          row.orderNumber?.toLowerCase().includes(q) ||
          row.item?.toLowerCase().includes(q) ||
          row.category?.toLowerCase().includes(q)
        );
      })
      .sort((a, b) => {
        const da = new Date(a.rawDate);
        const db = new Date(b.rawDate);
        return sortOrder === "recent" ? db - da : da - db;
      });
  }, [rows, searchText, sortOrder]);

  const sortedTransactions = React.useMemo(() => {
    return [...transactions].sort((a, b) => {
      const da = new Date(a.rawDate);
      const db = new Date(b.rawDate);
      return transSortOrder === "recent" ? db - da : da - db;
    });
  }, [transactions, transSortOrder]);


  const handleWithdrawRequest = () => {
    // Validate amount
    if (!amount || parseFloat(amount) <= 0) {
      setSnackbarState({
        open: true,
        message: "Please enter a valid amount",
        status: false,
      });
      return;
    }

    // Get pending balance (currently hardcoded, should come from API)
   
    const withdrawAmount = parseFloat(amount);

    // Validate if withdraw amount is greater than pending balance
    if (withdrawAmount > pendingBalance) {
      setSnackbarState({
        open: true,
        message: `Withdraw amount (₹${withdrawAmount.toLocaleString('en-IN')}) cannot be greater than pending balance (₹${pendingBalance.toLocaleString('en-IN')})`,
        status: false,
      });
      return;
    }

    setIsSubmittingWithdraw(true);

    // Call the API using useFetch hook
    fetchWithdrawRequest({
      vendor_id: id,
      amount: withdrawAmount,
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarState({ ...snackbarState, open: false });
  };

  const handlePrintInvoice = (
  orderId,
  orderItem,
  orderDetails,
  customerDetails,
  vendorDetails,
  orderSummary
) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Title
    doc.setFontSize(20);
    doc.text("INVOICE", pageWidth / 2, 20, null, null, "center");

    // Company Info
    doc.setFontSize(12);
    doc.text("Sthanick Web Services", pageWidth / 2, 35, null, null, "center");
    doc.text("Payment Invoice", pageWidth / 2, 45, null, null, "center");

    // Order Info
    doc.setFontSize(11);
    doc.text(`Order ID: #${orderId}`, 20, 60);
    doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 68);
    doc.text(`Item: ${orderItem}`, 20, 76);

    // Line
    doc.line(20, 85, pageWidth - 20, 85);

    // ==============================
    // CUSTOMER DETAILS
    // ==============================

    doc.setFontSize(13);
    doc.text("CUSTOMER DETAILS", 20, 100);

    doc.setFontSize(10);
    doc.text(`Name: ${customerDetails?.name || "N/A"}`, 20, 108);
    doc.text(`Phone: ${customerDetails?.phone || "N/A"}`, 20, 116);
    doc.text(`Email: ${customerDetails?.email || "N/A"}`, 20, 124);

    // ==============================
    // VENDOR DETAILS
    // ==============================

    doc.setFontSize(13);
    doc.text("VENDOR DETAILS", 120, 100);

    doc.setFontSize(10);
    doc.text(`Shop: ${vendorDetails?.shopName || "N/A"}`, 120, 108);
    doc.text(`Phone: ${vendorDetails?.phone || "N/A"}`, 120, 116);
    doc.text(`Email: ${vendorDetails?.email || "N/A"}`, 120, 124);

    // Divider
    doc.line(20, 135, pageWidth - 20, 135);

    // ==============================
    // ITEMS SECTION
    // ==============================

    let yPosition = 150;

    doc.setFontSize(13);
    doc.text("ITEMS", 20, yPosition);

    yPosition += 10;
    doc.setFontSize(10);

    orderDetails.forEach((item, index) => {
      doc.text(`${index + 1}. ${item.name}`, 25, yPosition);
      yPosition += 7;

      doc.text(`SKU: ${item.sku}`, 30, yPosition);
      doc.text(`Qty: ${item.qty}`, 120, yPosition);
      yPosition += 7;

      doc.text(`Price: ${item.price}`, 30, yPosition);
      doc.text(`Discount: ${item.discount}`, 120, yPosition);
      yPosition += 7;

      doc.text(`Total: ${item.total}`, 30, yPosition);

      yPosition += 10;
      doc.line(25, yPosition, pageWidth - 25, yPosition);

      yPosition += 10;
    });

    // ==============================
    // PAYMENT SUMMARY
    // ==============================

    doc.setFontSize(13);
    doc.text("PAYMENT SUMMARY", 20, yPosition);

    yPosition += 10;
    doc.setFontSize(10);

    doc.text("Subtotal:", 25, yPosition);
    doc.text(orderSummary.subtotal, pageWidth - 50, yPosition);

    yPosition += 8;
    doc.text("Shipping:", 25, yPosition);
    doc.text(orderSummary.shipping, pageWidth - 50, yPosition);

    yPosition += 8;
    doc.text("Discount:", 25, yPosition);
    doc.text(orderSummary.discount, pageWidth - 50, yPosition);

    yPosition += 10;

    doc.line(20, yPosition, pageWidth - 20, yPosition);

    yPosition += 10;

    doc.setFontSize(12);
    doc.text("TOTAL:", 25, yPosition);
    doc.text(orderSummary.total, pageWidth - 50, yPosition);

    // Footer
    yPosition += 25;
    doc.setFontSize(9);
    doc.text(
      "Thank you for your business!",
      pageWidth / 2,
      yPosition,
      null,
      null,
      "center"
    );

    doc.save(`Invoice_${orderId}.pdf`);
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Error generating PDF. Please try again.");
  }
};

  const handleRowToggle = (id) => {
    setOpenRowId(openRowId === id ? null : id);
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Payment Management
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}
        <VendorappBar title={"Payment Management"} onBackScreenName={handleScreeName} />

 {/* Tabs Section */}
 <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        sx={{
          // backgroundColor: "white",
          borderBottom: "1px solid #ddd",
          color: "black",
        }}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Order Payment History" />
        <Tab label="Agent Orders Payment History" />
       
      </Tabs>

      {selectedTab === 0 && (
        <>
        <Box p={2}>
          {/* Stats Cards */}
          <Box display="flex" justifyContent="space-around" alignItems="center" mb={3}>
            {/* Total Sold Card */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              borderRadius={6}
              boxShadow={2}
              p={2}
              bgcolor="white"
              width={200}
            >
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="#E3F2FD"
                  p={1.5}
                >
                  <ShoppingCartOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
                </Box>
                <Box ml={2}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Total Sold
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {deliveredOrdersLoading ? "..." : totalSold}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Total Products Card */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              borderRadius={6}
              boxShadow={2}
              p={2}
              bgcolor="white"
              width={200}
            >
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="#E3F2FD"
                  p={1.5}
                >
                  <ReceiptLongOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
                </Box>
                <Box ml={2}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Total Products
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {vendorProductsLoading ? "..." : totalProducts}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Total Value Card */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              borderRadius={6}
              boxShadow={2}
              p={2}
              bgcolor="white"
              width={200}
            >
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="#E3F2FD"
                  p={1.5}
                >
                  <AttachMoneyOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
                </Box>
                <Box ml={2}>
                  <Typography variant="subtitle2" color="textSecondary">
                     Total Value
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {deliveredOrdersLoading ? "..." : `₹${totalValue.toLocaleString('en-IN')}`}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Search Bar and Filter */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search by order number or ID"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Select
              size="small"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              variant="outlined"
              style={{ width: 200 }}
            >
              <MenuItem value="recent">Recent transactions</MenuItem>
              <MenuItem value="older">Older transactions</MenuItem>
            </Select>
          </Box>

          {/* Table */}
          <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight:"bold"}}>ORDER ID</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>ITEM</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>CATEGORY</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>DATE</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>PRICE</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>TYPE OF PAYMENT</TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>STATUS</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveredOrdersLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography>Loading orders...</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredSortedRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography>No orders found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredSortedRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                    <React.Fragment key={row.id}>
                      <TableRow>
                        <TableCell>{`#${row.orderNumber}`}</TableCell>
                        <TableCell>{row.item}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.price}</TableCell>
                        <TableCell>{row.paymentType}</TableCell>
                        <TableCell >
                          <Typography
                          sx={{fontWeight:"bold"}}
                            color={
                              row.status === "DELIVERED" || row.status === "Delivered" || row.status === "Completed"
                                ? "green"
                                : row.status === "Pending"
                                ? "orange"
                                : "red"

                            }
                          >
                            {row.status}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleRowToggle(row.id)}>
                            {openRowId === row.id ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      {/* Collapsible Row */}
                      <TableRow>
                        <TableCell style={{ padding: 0 }} colSpan={8}>
                          <Collapse
                            in={openRowId === row.id}
                            timeout="auto"
                            unmountOnExit
                          >
                            {row.details.length > 0 ? (
                              <Box margin={2}>
                                {/* Customer Information */}
                                <Box mb={2} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                    Customer Information:
                                  </Typography>
                                  <Box display="flex" gap={3} flexWrap="wrap">
                                    <Typography variant="body2">
                                      <strong>Name:</strong> {row.customerName}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Phone:</strong> {row.customerPhone}
                                    </Typography>
                                    {row.customerEmail !== "N/A" && (
                                      <Typography variant="body2">
                                        <strong>Email:</strong> {row.customerEmail}
                                      </Typography>
                                    )}
                                    <Typography variant="body2">
                                      <strong>Transaction ID:</strong> {row.transactionId}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Distance:</strong> {row.distance}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Order Details Table */}
                                <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                  Order Details:
                                </Typography>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        ORDER ID
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        VENDOR NAME
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        PRICE
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        QTY
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        DISC.
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        TOTAL
                                      </TableCell>
                                      <TableCell sx={{ fontWeight: "bold" }}>
                                        PRINT
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {row.details.map((detail) => (
                                      <TableRow key={detail.sku}>
                                        <TableCell>{detail.sku}</TableCell>
                                        <TableCell>{detail.name}</TableCell>
                                        <TableCell>{detail.price}</TableCell>
                                        <TableCell>{detail.qty}</TableCell>
                                        <TableCell
                                          sx={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {detail.discount}
                                        </TableCell>
                                        <TableCell>{detail.total}</TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() => handleInvoiceModalOpen(row.orderNumber, row.item, row.details, row.customerDetails,  row.vendorDetails,row.summary)}
                                            sx={{
                                              color: "#3f51b5",
                                              "&:hover": {
                                                backgroundColor: "rgba(63, 81, 181, 0.1)",
                                              },
                                            }}
                                          >
                                            <Print />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>

                                {/* Payment Summary */}
                                <Box mt={2} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                                  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                    Payment Summary:
                                  </Typography>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Subtotal:</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                      {row.summary.subtotal}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Shipping:</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                      {row.summary.shipping}
                                    </Typography>
                                  </Box>
                                  <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2">Discount:</Typography>
                                    <Typography variant="body2" fontWeight="bold" color="red">
                                      {row.summary.discount}
                                    </Typography>
                                  </Box>
                                  {row.summary.coupon !== "N/A" && (
                                    <Box display="flex" justifyContent="space-between" mb={1}>
                                      <Typography variant="body2">Coupon:</Typography>
                                      <Typography variant="body2" fontWeight="bold">
                                        {row.summary.coupon}
                                      </Typography>
                                    </Box>
                                  )}
                                  <Box display="flex" justifyContent="space-between" mt={2} pt={2} borderTop="2px solid #ddd">
                                    <Typography variant="subtitle1" fontWeight="bold">Total:</Typography>
                                    <Typography variant="subtitle1" fontWeight="bold" color="primary">
                                      {row.summary.total}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            ) : (
                              <Box margin={2}>
                                <Typography>No details available.</Typography>
                              </Box>
                            )}
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={filteredSortedRows.length}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Box>
        </>
      )}
{selectedTab === 1 && (
        <>

<Box p={2}>
    
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} gap={2}>
      {/* Units Sold Card */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={6}
        boxShadow={2}
        p={2}
        bgcolor="white"
        flex={1}

      >
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="50%"
            bgcolor="#E3F2FD"
            p={1.5}
           >
            <ShoppingCartOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
          </Box>
          <Box ml={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Units Sold
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {isListingOrdersLoading ? "..." : unitsSold}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Total Revenue Card */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={6}
        boxShadow={2}
        p={2}
        bgcolor="white"
        flex={1}

      >
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="50%"
            bgcolor="#E3F2FD"
            p={1.5}
          >
            <AttachMoneyOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
          </Box>
          <Box ml={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Total Revenue
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {isListingOrdersLoading ? "..." : `₹${totalRevenue.toLocaleString('en-IN')}`}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Agent Total Order Card */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={6}
        boxShadow={2}
        p={2}
        bgcolor="white"
        flex={1}

      >
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="50%"
            bgcolor="#E3F2FD"
            p={1.5}
          >
            <ReceiptLongOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
          </Box>
          <Box ml={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Agent Total Order
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {isVendorListingsLoading ? "..." : agentCount}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Pending Balance Card */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={6}
        boxShadow={2}
        p={2}
        bgcolor="white"
        flex={1}

      >
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="50%"
            bgcolor="#E3F2FD"
            p={1.5}
          >
            <AccountBalanceWalletOutlinedIcon style={{ fontSize: 24, color: '#2196F3' }} />
          </Box>
          <Box ml={2}>
            <Typography variant="subtitle2" color="textSecondary">
              Pending Balance
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {isAGentMetricsLoading ? "..." : `₹${pendingBalance.toLocaleString('en-IN')}`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>

    {/* Withdraw Money Button */}
    <Box display="flex" justifyContent="flex-end" mb={3}>
      <Button
        variant="contained"
        color="primary"
        style={{ textTransform: 'none', borderRadius: '16px' }}
        onClick={handleModalOpen}
        startIcon={<AccountBalanceWalletOutlinedIcon />}
      >
        Withdraw Money
      </Button>
    </Box>

      {/* Last Transaction Section */}
      <Box mb={3}>
        
        <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          Last Transaction
        </Typography>
          <Box display="flex" gap={1}>
            <Select
              size="small"
              value={transSortOrder}
              onChange={(e) => setTransSortOrder(e.target.value)}
              variant="outlined"
              style={{ width: 200 }}
            >
              <MenuItem value="recent">Recent transactions</MenuItem>
              <MenuItem value="older">Older transactions</MenuItem>
            </Select>
            <Select
              size="small"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <MenuItem value="This Month">This Month</MenuItem>
              <MenuItem value="Last Month">Last Month</MenuItem>
            </Select>
          </Box>
        </Box>
        <TableContainer component={Paper} sx={{borderRadius:"20px"}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight:"bold"}}>REQUEST DATE</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>TIME</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>AMOUNT</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>BANK</TableCell>
                <TableCell sx={{fontWeight:"bold"}}>STATUS</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {paymentRequestsLoading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography>Loading payment requests...</Typography>
                  </TableCell>
                </TableRow>
              ) : sortedTransactions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography>No payment requests found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                sortedTransactions
                  .slice(transPage * transRowsPerPage, transPage * transRowsPerPage + transRowsPerPage)
                  .map((transaction) => (
                  <React.Fragment key={transaction.id}>
                    <TableRow>
                      <TableCell>{transaction.requestDate}</TableCell>
                      <TableCell>{transaction.time}</TableCell>
                      <TableCell>{transaction.amount}</TableCell>
                      <TableCell>{transaction.bank}</TableCell>
                      <TableCell>
                        <Typography sx={{fontWeight:"bold"}}
                          color={transaction.status === "Pending" ? "orange" : "green"}
                        >
                          {transaction.status}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleRowToggle(transaction.id)}>
                          {openRowId === transaction.id ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    {/* Collapsible Row */}
                    <TableRow>
                      <TableCell colSpan={6} style={{ padding: 0 }}>
                        <Collapse in={openRowId === transaction.id} timeout="auto" unmountOnExit>
                          <Box margin={2} display="flex" gap={3}>
                            {/* Transaction Information */}
                            <Box flex={1}>
                              <Typography variant="subtitle2" mb={1}>
                                <strong>Transaction ID:</strong> {transaction.details.transactionId}
                              </Typography>
                              <Typography variant="subtitle2" mb={1}>
                                <strong>Date / Time:</strong> {transaction.details.dateTime}
                              </Typography>
                              <Typography variant="subtitle2" mb={2}>
                                <strong>Bank Account No:</strong> {transaction.details.bankAccount}
                              </Typography>
                              <Button variant="text" color="primary" >
                                Contact Support
                              </Button>
                            </Box>

                            {/* Image Section */}
                            <Box
                              flex={1}
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                              bgcolor="#f5f5f5"
                              borderRadius={2}
                              p={2}
                            >
                              <Typography variant="subtitle2" fontWeight="bold" mb={1}>
                                Transaction Receipt
                              </Typography>
                              <Box
                                component="img"
                                src={transaction.details.receiptImage || "/placeholder-receipt.png"}
                                alt="Transaction Receipt"
                                sx={{
                                  width: "100%",
                                  maxWidth: 300,
                                  height: 200,
                                  objectFit: "cover",
                                  borderRadius: 1,
                                  border: "1px solid #ddd",
                                  bgcolor: "white"
                                }}
                              />
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={sortedTransactions.length}
          page={transPage}
          onPageChange={(e, newPage) => setTransPage(newPage)}
          rowsPerPage={transRowsPerPage}
          onRowsPerPageChange={(e) => { setTransRowsPerPage(parseInt(e.target.value, 10)); setTransPage(0); }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Box>

      {/* Withdraw Money Modal */}
      <Modal open={openModal} onClose={handleModalClose}>
      <Box
        p={4}
        bgcolor="white"
        borderRadius={2}
        boxShadow={24}
        style={{
          width: "min(400px, calc(100vw - 24px))",
          maxWidth: "calc(100vw - 24px)",
          margin: "auto",
          marginTop: "10%",
        }}
      >
        <Typography variant="h6" mb={2} textAlign="center">
          Withdraw Request
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="body1" fontWeight="bold">
            Request date:
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{fontWeight:"bold"}}>
            {requestDate}
          </Typography>
        </Box>
        <TextField
          label="Enter Amount"
          type="number"
          fullWidth
          margin="normal"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          InputProps={{
            startAdornment: (
              <Typography variant="body1" style={{ marginRight: 8 }}>
                ₹
              </Typography>
            ),
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isTotalAmount}
              onChange={(e) => setIsTotalAmount(e.target.checked)}
              color="primary"
            />
          }
          label="Total Amount"
        />
        <Box display="flex" flexDirection="column" alignItems="center" mt={3}>
          <Button
            variant="contained"
            onClick={handleWithdrawRequest}
            fullWidth
            disabled={isSubmittingWithdraw || withdrawRequestLoading}
            style={{ marginBottom: 12, backgroundColor: "#00796b", color: "white" }}
          >
            {isSubmittingWithdraw || withdrawRequestLoading ? "Submitting..." : "Request Withdraw"}
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleModalClose}
            disabled={isSubmittingWithdraw || withdrawRequestLoading}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>

    </Box>

        </>
       )}

      {/* Invoice Download Modal */}
      <Modal open={openInvoiceModal} onClose={handleInvoiceModalClose}>
        <Box
          p={4}
          bgcolor="white"
          borderRadius={2}
          boxShadow={24}
          sx={{
            width: { xs: "calc(100vw - 24px)", sm: 650 },
            maxWidth: "100%",
            maxHeight: "80vh",
            margin: "auto",
            marginTop: "2%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" mb={2} textAlign="center" fontWeight="bold">
            Invoice Details
          </Typography>

          {selectedInvoiceData && (
            <Box sx={{ flexGrow: 1, overflowY: "auto", mb: 2 }}>
              {/* Order Information */}
              <Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
                <Typography variant="body1" mb={1}>
                  <strong>Order ID:</strong> #{selectedInvoiceData.orderId}
                </Typography>
                <Typography variant="body1" mb={1}>
                  <strong>Item:</strong> {selectedInvoiceData.orderItem}
                </Typography>
                <Typography variant="body1" mb={1}>
                  <strong>Date:</strong> {new Date().toLocaleDateString()}
                </Typography>
              </Box>

              {/* Customer Details */}
<Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
  <Typography variant="subtitle1" fontWeight="bold" mb={1}>
    Customer Details
  </Typography>

  <Typography variant="body2" mb={0.5}>
    <strong>Name:</strong>{" "}
   {selectedInvoiceData?.customerDetails?.name}
  </Typography>

  <Typography variant="body2" mb={0.5}>
    <strong>Phone:</strong>{" "}
   {selectedInvoiceData?.customerDetails?.phone || "N/A"}
  </Typography>

  {selectedInvoiceData?.customerDetails?.email !== "N/A" && (
    <Typography variant="body2">
      <strong>Email:</strong>{" "}
      {selectedInvoiceData?.customerDetails?.email}
    </Typography>
  )}
</Box>
<Box mb={3} p={2} bgcolor="#f5f5f5" borderRadius={2}>
<Typography variant="h6">Vendor Details</Typography>

<Typography>
Shop Name: {selectedInvoiceData?.vendorDetails?.shopName || "N/A"}
</Typography>

<Typography>
Vendor Name: {selectedInvoiceData?.vendorDetails?.vendorName || "N/A"}
</Typography>

<Typography>
Phone: {selectedInvoiceData?.vendorDetails?.phone || "N/A"}
</Typography>

<Typography>
Email: {selectedInvoiceData?.vendorDetails?.email || "N/A"}
</Typography>

<Typography>
Address: {selectedInvoiceData?.vendorDetails?.address || "N/A"}
</Typography>
</Box>
              {/* Items Details */}
              <Box mb={3}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Order Items
                </Typography>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>SKU</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>NAME</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>PRICE</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>QTY</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>DISC.</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>TOTAL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedInvoiceData.orderDetails.map((item) => (
                        <TableRow key={item.sku}>
                          <TableCell>{item.sku}</TableCell>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.price}</TableCell>
                          <TableCell>{item.qty}</TableCell>
                          <TableCell sx={{ color: "red", fontWeight: "bold" }}>
                            {item.discount}
                          </TableCell>
                          <TableCell>{item.total}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Payment Summary */}
              <Box p={2} bgcolor="#f5f5f5" borderRadius={2}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  Payment Summary
                </Typography>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Subtotal:</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {selectedInvoiceData.orderSummary.subtotal}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Shipping:</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {selectedInvoiceData.orderSummary.shipping}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body2">Discount:</Typography>
                  <Typography variant="body2" fontWeight="bold" color="red">
                    {selectedInvoiceData.orderSummary.discount}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" mt={2} pt={2} borderTop="2px solid #ddd">
                  <Typography variant="h6" fontWeight="bold">Total:</Typography>
                  <Typography variant="h6" fontWeight="bold" color="primary">
                    {selectedInvoiceData.orderSummary.total}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* Buttons Fixed at Bottom */}
          <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
            <Button
              variant="contained"
              onClick={() => {
                if (selectedInvoiceData) {
                  handlePrintInvoice(
                    selectedInvoiceData.orderId,
                    selectedInvoiceData.orderItem,
                    selectedInvoiceData.orderDetails,
                    selectedInvoiceData.customerDetails, // ✅ correct
                    selectedInvoiceData.vendorDetails, // ✅ correct
                    selectedInvoiceData.orderSummary  
                  );
                  handleInvoiceModalClose();
                }
              }}
              fullWidth
              style={{
                marginBottom: 12,
                backgroundColor: "#00796b",
                color: "white",
                textTransform: "none"
              }}
            >
              Download Invoice
            </Button>
            <Button
              variant="text"
              color="primary"
              onClick={handleInvoiceModalClose}
              style={{ textTransform: "none" }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarState.status ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {snackbarState.message}
        </Alert>
      </Snackbar>

    </Box>
  );
}
